import { create } from 'zustand'
import type { HelpdeskRequest } from '@/types/helpdesk'

const MOCK: HelpdeskRequest[] = [
  {
    id: 'R000001',
    clientName: 'Alberto Ripley',
    clientOrg: 'SM Investments',
    requestType: 'Break fix',
    subject: 'Dell Latitude 54...',
    description:
      'Laptop keeps freezing when opening POS software. Happens after 10 minutes of use.',
    requestedAt: new Date(Date.now() - 82_000).toISOString(), // timer
    status: 'NEW',
  },
  {
    id: 'R000002',
    clientName: 'Susan Babin',
    clientOrg: 'Ayala Corporation',
    requestType: 'Break fix',
    subject: 'Dell Inspiron 15 ...',
    description:
      'Keyboard input delayed. Touchpad intermittently stops working.',
    requestedAt: new Date(Date.now() - 92_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000003',
    clientName: 'Carol Lam',
    clientOrg: 'JG Summit Holdings',
    requestType: 'Break fix',
    subject: 'HP LaserJet Pro lorem ipsum lorem ipsum lorem ipsum',
    description:
      'My HP LaserJet Pro printer is not printing anything. When I send a document to print, it stays in the queue and nothing comes out.',
    requestedAt: new Date(Date.now() - 102_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000005',
    clientName: 'Janelle Santos',
    clientOrg: 'Robinsons Retail Holdings',
    requestType: 'Installing',
    subject: 'Install MS Office 365',
    description:
      'Need Office 365 installed and activated for a new user. Please include Teams and Outlook configuration.',
    requestedAt: new Date(Date.now() - 112_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000006',
    clientName: 'Miguel Tan',
    clientOrg: 'San Miguel Corporation',
    requestType: 'Preventive Maintenance',
    subject: 'Quarterly workstation PM',
    description:
      'Schedule preventive maintenance for 12 workstations (cleaning, updates, basic health checks). Preferred time: 2–4 PM.',
    requestedAt: new Date(Date.now() - 132_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000007',
    clientName: 'Aira Cruz',
    clientOrg: 'BDO Unibank',
    requestType: 'Follow Up',
    subject: 'VPN disconnects frequently',
    description:
      'VPN drops every 5–10 minutes. Internet is stable. Affected apps: Outlook and Teams.',
    requestedAt: new Date(Date.now() - 152_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000008',
    clientName: 'Paolo Reyes',
    requestType: 'Adhoc Reliever',
    subject: 'Need onsite reliever for shift',
    description:
      'Requesting an adhoc reliever for front desk IT support (8 AM–5 PM) due to primary technician on leave.',
    requestedAt: new Date(Date.now() - 172_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000020',
    clientName: 'Grace Villanueva',
    clientOrg: 'SM Investments',
    requestType: 'Follow Up',
    subject: 'POS app freezes after update',
    description:
      'POS software started freezing after Windows update. Happens ~10 minutes after login, then requires restart.',
    requestedAt: new Date(Date.now() - 86_000).toISOString(), // ~1:26 ago
    status: 'NEW',
  },
  {
    id: 'R000009',
    clientName: 'Daniel Chua',
    clientOrg: 'Globe Telecom',
    requestType: 'Break fix',
    subject: 'Lenovo ThinkPad - random BSOD',
    description:
      'Laptop blue screens intermittently during video calls. Please check drivers and memory diagnostics.',
    requestedAt: new Date(Date.now() - 96_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000010',
    clientName: 'Katherine Dizon',
    clientOrg: 'Manila Water',
    requestType: 'Installing',
    subject: 'Install Zoom + headset setup',
    description:
      'Need Zoom installed and configured. Also help setting default audio devices for USB headset.',
    requestedAt: new Date(Date.now() - 106_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000014',
    clientName: 'Ivan Bautista',
    clientOrg: 'AboitizPower',
    requestType: 'Preventive Maintenance',
    subject: 'Laptop running slow (PM request)',
    description:
      'Requesting preventive maintenance: cleanup, updates, and storage check. Device is slow during startup.',
    requestedAt: new Date(Date.now() - 116_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000018',
    clientName: 'Sophie Aquino',
    clientOrg: 'Petron',
    requestType: 'Ad Hoc',
    subject: 'Shared drive access request',
    description:
      'Need access to Finance shared drive and correct permissions for monthly reports folder.',
    requestedAt: new Date(Date.now() - 126_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000019',
    clientName: 'Arman Dela Cruz',
    clientOrg: 'Meralco',
    requestType: 'Break fix',
    subject: 'No internet on Ethernet',
    description:
      'PC can connect to Wi‑Fi but Ethernet says “Unidentified network”. Need help with adapter/IP settings.',
    requestedAt: new Date(Date.now() - 136_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000004',
    clientName: 'Marsha Noland',
    clientOrg: 'Aboitiz Equity Ventures',
    requestType: 'Ad Hoc',
    subject: 'HP DeskJet 2332',
    description:
      'Printer shows error light blinking. Need assistance with troubleshooting.',
    requestedAt: new Date(Date.now() - 122_000).toISOString(),
    status: 'ACKNOWLEDGED',
    acknowledgedAt: new Date(Date.now() - 40_000).toISOString(),
    currentStatusLabel: 'PT Creation',
  },
  {
    id: 'R000011',
    clientName: 'Noel Garcia',
    clientOrg: 'PLDT',
    requestType: 'Break fix',
    subject: 'Desktop won’t boot',
    description:
      'Desktop shows power light but no display. Tried different monitor and cable. Need assistance ASAP.',
    requestedAt: new Date(Date.now() - 210_000).toISOString(),
    status: 'ACKNOWLEDGED',
    acknowledgedAt: new Date(Date.now() - 95_000).toISOString(),
    currentStatusLabel: 'IVR Contacted',
  },
  {
    id: 'R000012',
    clientName: 'Hannah Lim',
    clientOrg: 'UnionBank',
    requestType: 'Ad Hoc',
    subject: 'Email signature update',
    description:
      'Need help updating Outlook email signature for the whole team (new branding).',
    requestedAt: new Date(Date.now() - 240_000).toISOString(),
    status: 'ACKNOWLEDGED',
    acknowledgedAt: new Date(Date.now() - 120_000).toISOString(),
    currentStatusLabel: 'Open',
  },
  {
    id: 'R000013',
    clientName: 'Rico Mendoza',
    clientOrg: 'Metrobank',
    requestType: 'Installing',
    subject: 'Install printer driver',
    description:
      'Need the correct network printer driver installed (Canon iR-ADV) and set as default for accounting workstation.',
    requestedAt: new Date(Date.now() - 280_000).toISOString(),
    status: 'ACKNOWLEDGED',
    acknowledgedAt: new Date(Date.now() - 140_000).toISOString(),
    currentStatusLabel: 'PT Creation',
  },
  {
    id: 'R000015',
    clientName: 'Bianca Torres',
    clientOrg: 'RCBC',
    requestType: 'Follow Up',
    subject: 'Password reset still not working',
    description:
      'User can’t log in after password reset; receives “account locked” message. Need to verify AD status and unlock.',
    requestedAt: new Date(Date.now() - 310_000).toISOString(),
    status: 'ACKNOWLEDGED',
    acknowledgedAt: new Date(Date.now() - 155_000).toISOString(),
    currentStatusLabel: 'Open',
  },
  {
    id: 'R000016',
    clientName: 'Jerome Pascual',
    clientOrg: 'DMCI Holdings',
    requestType: 'Installing',
    subject: 'Install Adobe Reader + default PDF',
    description:
      'Need Adobe Reader installed and set as default for PDFs. Browser downloads currently opening in Edge.',
    requestedAt: new Date(Date.now() - 190_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000017',
    clientName: 'Leah Ramos',
    clientOrg: 'ACEN',
    requestType: 'Break fix',
    subject: 'Scanner not detected',
    description:
      'Epson scanner not detected on USB. Device manager shows unknown device. Need driver reinstall and test scan.',
    requestedAt: new Date(Date.now() - 205_000).toISOString(),
    status: 'NEW',
  },
  {
    id: 'R000021',
    clientName: 'Omar Navarro',
    clientOrg: 'Cebu Pacific',
    requestType: 'Adhoc Reliever',
    subject: 'Temporary IT support (weekend)',
    description:
      'Requesting weekend onsite reliever for event support (Sat 9 AM–6 PM). Setup includes projector, microphones, and laptops.',
    requestedAt: new Date(Date.now() - 360_000).toISOString(),
    status: 'ACKNOWLEDGED',
    acknowledgedAt: new Date(Date.now() - 200_000).toISOString(),
    currentStatusLabel: 'IVR Contacted',
  },
  {
    id: 'R000022',
    clientName: 'Tina Delgado',
    requestType: 'Preventive Maintenance',
    subject: 'New laptop onboarding checklist',
    description:
      'Need PM/onboarding for a new laptop: updates, endpoint security, printer setup, and baseline performance check.',
    requestedAt: new Date(Date.now() - 175_000).toISOString(),
    status: 'NEW',
  },
]



type HelpdeskState = {
  items: HelpdeskRequest[]
  acknowledge: (id: string) => void
  setItems: (items: HelpdeskRequest[]) => void

  urgentNewPage: number
  urgentNewPerPage: number
  setUrgentNewPage: (page: number) => void
  setUrgentNewPerPage: (perPage: number) => void

  acknowledgedPage: number
  acknowledgedPerPage: number
  setAcknowledgedPage: (page: number) => void
  setAcknowledgedPerPage: (perPage: number) => void
}

export const useHelpdeskStore = create<HelpdeskState>((set) => ({
  items: MOCK,

  setItems: (items) => set({ items }),

  acknowledge: (id) =>
    set((state) => ({
      items: state.items.map((x) =>
        x.id === id
          ? {
              ...x,
              status: 'ACKNOWLEDGED',
              acknowledgedAt: new Date().toISOString(),
              currentStatusLabel: x.currentStatusLabel ?? 'Open',
            }
          : x
      ),
    })),

  // defaults
  urgentNewPage: 1,
  urgentNewPerPage: 10,
  setUrgentNewPage: (page) => set({ urgentNewPage: page }),
  setUrgentNewPerPage: (perPage) => set({ urgentNewPerPage: perPage, urgentNewPage: 1 }),

  acknowledgedPage: 1,
  acknowledgedPerPage: 10,
  setAcknowledgedPage: (page) => set({ acknowledgedPage: page }),
  setAcknowledgedPerPage: (perPage) => set({ acknowledgedPerPage: perPage, acknowledgedPage: 1 }),
}))